// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7988":"013b7efb61b333df","9114":"68b935cb87388d34"}[chunkId] + ".css";
};